import React, { Fragment } from 'react';
import { config } from 'helpers';
import { Video as VideoComponent } from 'components';
import css from './home.scss';

export function Video(props) {
  return (
    <div className={css.video}>
      <div className={css.smallContainer}>
        { config.sw
          ? <>
            <h3>How to achieve your most significant life goals</h3>
            <VideoComponent src="https://www.youtube.com/embed/yqOwbT7I3f0" aspectRatio={3/4} />
          </>
          : <>
            <h3>Achieve your most significant life goals!</h3>
          </>
        }
      </div>
    </div>
  );
}
